var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotPassed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2048_7822",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 64,
    width: 64,
    height: 64,
    transform: "rotate(-180 64 64)",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2048_7822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.22449 40.1897C7.82421 40.3874 8.22403 40.3874 8.62384 40.3874C8.42393 40.3874 8.82375 40.3874 8.62384 40.3874L23.417 40.3874L23.417 51.4546C23.417 54.0237 25.416 56 28.0148 56L34.0121 56C34.8117 56 35.2115 55.8024 35.8112 55.6047C36.6109 55.4071 37.2106 54.8142 37.8103 54.2214L48.2055 40.9802L55.4021 40.9802C58.0009 40.7826 60 38.8063 60 36.2372L60 10.5455C60 7.9763 58.0009 6.00001 55.4021 6.00001L16.82 6.00001C15.8205 6.00001 14.821 6.39526 14.0213 6.98815C13.2217 7.58103 12.8219 8.37155 12.622 9.16206L4.22588 34.4585C3.42625 37.0277 4.82561 39.5968 7.22449 40.1897ZM51.8038 14.8933L51.8038 31.8893L48.2055 31.8893L48.2055 14.8933L51.8038 14.8933ZM39.8094 14.8933L39.8094 36.6324L32.4128 46.1186L32.4128 35.8419C32.4128 33.2727 30.4137 31.2965 27.8149 31.2965L14.821 31.2965L20.2185 14.8933L39.8094 14.8933Z",
    fill: "#C63838"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotPassed);
export default __webpack_public_path__ + "static/media/not-passed.21fcc13f273e8357269b75e1029ffbfa.svg";
export { ForwardRef as ReactComponent };